import React, { useEffect, useState, useMemo, useRef } from "react";
import SelectInput from "./../../components/common/ui/Inputs/SelectInput";
import { DateInput, TextInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { PODAction } from "../../_store/pod.slice";
import { masterActions } from "../../_store";
import { history } from "../../_helpers";
import generateXlsx from "../../components/common/export/generateXlsx";
import { useLocation } from "react-router-dom";
import CustomLoader from "../../components/common/ui/Loader";
import { exportDate, fDate, getCurrentDate } from "../../utils/formatTime";

const DEFAULT_GENDER_ID = 0;
const DEFAULT_ACTIVE_STATUS = 1; // Active status default

const InmateLoginLog = () => {
  const dispatch = useDispatch();
  // Destructuring dropdownOptions from the state in a single useSelector call
  const {
    logHistoryLastName: logHistoryLastName,
    logHistorFirstName: logHistorFirstName,
  } = useSelector((state) => state.master);
  const { commonFacilityCode: facilityCode } = useSelector(
    (state) => state.auth
  );

  const loading = useSelector((state) => state.pod?.loading);
  const { genderDropdown } = useSelector((state) => state.dropdownOptions);
  const logHistoryFullData = useSelector(
    (state) => state.pod?.logHistoryFullData || {}
  );
  const logHistoryData = useSelector((state) => state.pod?.logHistoryData);
  const getSpecPodKiosk = useSelector((state) => state.pod?.getSpecPodKiosk);
  const initiallogHistoryData = useSelector(
    (state) => state.pod?.initiallogHistoryData
  );
  const [showSearchFields, setShowSearchFields] = useState(false);
  const prevFacilityCodeRef = useRef(facilityCode); // Track previous value
  const shouldShowExcelExport = logHistoryData?.DataList?.length > 0;
  const [isLoading, setisLoading] = useState(false);
  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
    { value: 2, label: "Both" },
  ];

  const isPageChanged = useRef(false);

  const location = useLocation(); // Get the location object
  const { state } = location; // Destructure state from location

  // Access the passed id from state
  const podID = state?.id; // Use optional chaining to avoid errors if state is undefined

  // const [initiallogHistoryData, setinitiallogHistoryData] = useState({
  //   InmateResidentId: "",
  //   FacilityID: 0,
  //   FirstName: "",
  //   LastName: "",
  //   PodID: 0,
  //   KiosksCode: "",
  //   KiosksID: 0,
  //   GenderID: DEFAULT_GENDER_ID,
  //   FromDate: "",
  //   ToDate: "",
  //   ActiveStatus: DEFAULT_ACTIVE_STATUS,
  //   PageNo: DEFAULT_PAGE_NO,
  //   RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
  //   SortBy: "",
  // });

  useEffect(() => {
    if (podID) {
      const searchData = { ...initiallogHistoryData };
      searchData.PodID = podID;
      searchData.FacilityID = facilityCode;
      dispatch(PODAction?.updateInitiallogHistoryData(searchData));
      setisLoading(true);
      dispatch(
        PODAction.LoadInmateLoginLogHistory({
          ...initiallogHistoryData,
          RowCountPerPage: 10,
          PageNo: 1,
          PodID: podID,
          FacilityID: facilityCode,
        })
      ).then(() => {
        setisLoading(false);
      }).finally(() => {
        setisLoading(false);
      });
      dispatch(PODAction.resetInitiallogHistoryData());
    }
  }, [
    podID,
  ]);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate("PODList");
    }
  }, [facilityCode, dispatch]);

  useEffect(() => {
    dispatch(
      masterActions.GetInmateFirstName({
        facilityID: facilityCode,
        LastName: "",
      })
    );
    dispatch(
      masterActions.GetInmateLastName({
        facilityID: facilityCode,
        FirstName: "",
      })
    );
  }, [facilityCode]);

  useEffect(() => {
    if (podID) {
      dispatch(
        PODAction.GetPODKioskList({ PodID: podID, facilityID: facilityCode })
      );
    }
  }, [podID]);

  // Load facility dropdown on component mount
  useEffect(() => {
    const loadFacilities = async () => {
      try {
        await dispatch(
          masterActions.LoadFacilityDropDown({
            FacilityID: 0,
            ActiveStatus: DEFAULT_ACTIVE_STATUS,
          })
        );
      } catch (error) {
        console.error("Error loading facilities:", error);
        // Optionally dispatch an error action or show a notification
      }
    };
    loadFacilities();
  }, []);

  // Column configuration for the table
  const columns = useMemo(
    () => [
      {
        name: "Date",
        key: "LogInDateTime",
        selector: (row) => row.LogInDateTime,
        sortable: true,
      },
      {
        name: "Inmate ID ",
        key: "InmateID",
        selector: (row) => row.InmateResidentId,
        sortable: true,
      },
      {
        name: "POD Name",
        key: "PodCode",
        selector: (row) => row.PODName,
        sortable: true,
      },
      {
        name: "Kiosks Code",
        key: "KiosksCode",
        selector: (row) => row.KiosksCode,
        sortable: true,
      },
      {
        name: "Login Status",
        key: "LoginStatus",
        selector: (row) => row.LoginStatus,
        sortable: true,
      },
    ],
    []
  );

  // Function to handle form submission
  const handlePODSearchSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    // Check if any relevant POD data is available to submit
    const { FirstName, LastName, GenderID, ActiveStatus } =
      initiallogHistoryData;
    if (
      FirstName ||
      LastName ||
      GenderID !== undefined ||
      ActiveStatus !== undefined
    ) {
      const updatedloghistoryData = {
        ...initiallogHistoryData,
        PodID: podID,
        FacilityID: facilityCode,
        RowCountPerPage: 10,
        PageNo: 1,
      };
      dispatch(PODAction?.updateInitiallogHistoryData(updatedloghistoryData));
      // setinitiallogHistoryData(updatedloghistoryData); // Update the state with the new data

      dispatch(PODAction.LoadInmateLoginLogHistory(updatedloghistoryData)); // Dispatch the action to load POD list
    }
  };

  // Function to handle form submission
  // const handlePODSearchSubmit = (e) => {
  //   e.preventDefault(); // Prevent default form submission behavior
  // }

  // Function to reset the state to default values for the POD list
  // const resetPODList = () => {
  //   // Default values for reset
  // const DEFAULT_RESET_STATE = {
  //   InmateResidentId: "",
  //   FacilityID: facilityCode, // Assuming this is dynamic and updated elsewhere
  //   FirstName: "",
  //   LastName: "",
  //   PodID: podID, // Assuming this is dynamic and updated elsewhere
  //   KiosksCode: "",
  //   GenderID: DEFAULT_GENDER_ID,
  //   FromDate: "",
  //   ToDate: "",
  //   ActiveStatus: DEFAULT_ACTIVE_STATUS,
  //   PageNo: DEFAULT_PAGE_NO,
  //   RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
  //   SortBy: "",
  // };
  //   dispatch(PODAction?.resetInitiallogHistoryData());
  //   // setinitiallogHistoryData(DEFAULT_RESET_STATE);
  //   // Early return if facilityCode is not available
  //   if (!facilityCode) return;

  //   // Dispatch actions to reset names and load log history
  //   dispatch(
  //     masterActions.GetInmateLastName({
  //       facilityID: facilityCode,
  //       FirstName: "",
  //     })
  //   );
  //   dispatch(
  //     masterActions.GetInmateFirstName({
  //       facilityID: facilityCode,
  //       LastName: "",
  //     })
  //   );
  //   dispatch(PODAction.LoadInmateLoginLogHistory(DEFAULT_RESET_STATE));
  // };
  const resetPODList = () => {
    isPageChanged.current = false;
    const resetSearchData = {
      // InmateResidentId: "",
      // FacilityID: facilityCode, // Assuming this is dynamic and updated elsewhere
      // FirstName: "",
      // LastName: "",
      // PodID: podID, // Assuming this is dynamic and updated elsewhere
      // KiosksCode: "",
      // GenderID: DEFAULT_GENDER_ID,
      // FromDate: "",
      // ToDate: "",
      // ActiveStatus: DEFAULT_ACTIVE_STATUS,
      // PageNo: DEFAULT_PAGE_NO,
      // RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
      // SortBy: "",

      InmateResidentId: "",
      FacilityID: facilityCode,
      FirstName: "",
      FirstNameID: "",
      LastName: "",
      LastNameID: "",
      PodID: podID,
      KiosksCode: "",
      KiosksID: 0,
      GenderID: DEFAULT_GENDER_ID,
      FromDate: "",
      ToDate: "",
      ActiveStatus: DEFAULT_ACTIVE_STATUS,
      PageNo: 1,
      RowCountPerPage: 10,
      SortBy: "",
    };
    dispatch(PODAction.updateInitiallogHistoryData(resetSearchData));
    dispatch(PODAction.LoadInmateLoginLogHistory(resetSearchData));
    dispatch(
      masterActions.GetInmateFirstName({
        facilityID: facilityCode,
        LastName: "",
      })
    );
    dispatch(
      masterActions.GetInmateLastName({
        facilityID: facilityCode,
        FirstName: "",
      })
    );
  };

  //The function effectively updates the state based on input changes.
  const handleInmateID = (e) => {
    const searchData = { ...initiallogHistoryData };
    const { name, value } = e?.target;
    const regex = /^[0-9\s]*$/;
    if (!regex.test(value)) return;
    searchData[name] = value;
    dispatch(PODAction?.updateInitiallogHistoryData(searchData));
    // Update state using setinitiallogHistoryData with previous state
    // setinitiallogHistoryData((prev) => ({
    //   ...prev,
    //   [name]: value, // Set the value dynamically based on input name
    // }));
  };

  // const updateLastandFirstName = (selectedOption, name) => {
  //   const paramsCopy = { ...initiallogHistoryData };
  // paramsCopy.RowCountPerPage = 10;
  // paramsCopy.PageNo = 1;
  //   const isLastName = name === "LastName";

  //   const clearData = () => {
  //     paramsCopy[name] = "";
  //     if (isLastName) {
  //       paramsCopy.FirstName = "";
  //       paramsCopy.FirstNameLabel = "";
  //     } else {
  //       paramsCopy.LastName = "";
  //       paramsCopy.LastNameLabel = "";
  //     }
  //     dispatch(PODAction?.updateInitiallogHistoryData(paramsCopy));
  //     // setinitiallogHistoryData(paramsCopy);
  // dispatch(
  //   masterActions.GetInmateFirstName({
  //     facilityID: facilityCode,
  //     LastName: "",
  //   })
  // );
  //     dispatch(
  //       masterActions.GetInmateLastName({
  //         facilityID: facilityCode,
  //         FirstName: "",
  //       })
  //     );
  //   };

  //   const updateData = () => {
  //     paramsCopy[name] = selectedOption.value;
  //     // setinitiallogHistoryData(paramsCopy);

  //     dispatch(PODAction?.updateInitiallogHistoryData(paramsCopy));
  //     if (isLastName) {
  //       dispatch(
  // masterActions.GetInmateFirstName({
  //   facilityID: facilityCode,
  //   LastName: selectedOption.label,
  // })
  //       );
  //     } else {
  //       dispatch(
  //         masterActions.GetInmateLastName({
  //           facilityID: facilityCode,
  //           // FirstName: selectedOption.label,
  //           FirstName: "",
  //         })
  //       );
  //     }
  //   };

  //   if (selectedOption === null || selectedOption?.value === 0) {
  //     clearData();
  //   } else {
  //     updateData();
  //   }

  //   const updatedFacilityID = {
  //     ...paramsCopy,
  //     FacilityID: facilityCode,
  //     PodID: podID,
  //   };
  //   dispatch(PODAction?.updateInitiallogHistoryData(paramsCopy));
  //   // setinitiallogHistoryData(paramsCopy);
  //   dispatch(PODAction.LoadInmateLoginLogHistory(updatedFacilityID));
  // };

  // // Function to handle dropdown changes for different fields
  // const updateSelectedOption = (selectedOption, name) => {
  //   // Create a shallow copy of the initial log history data
  //   const paramsCopy = { ...initiallogHistoryData };
  //   paramsCopy.RowCountPerPage = 10;
  //   paramsCopy.PageNo = 1;
  //   // Helper function to update state and params
  //   const updatePODData = (value) => {
  //     const updatedValue = value != null ? value : ""; // Allow empty values
  //     setinitiallogHistoryData((prev) => ({
  //       ...prev,
  //       [name]: updatedValue,
  //     }));
  //     paramsCopy[name] = updatedValue;
  //   };

  //   // Handle specific cases based on field name
  //   switch (name) {
  //     case "GenderID":
  //       updatePODData(parseInt(selectedOption?.value || 0, 10));
  //       break;

  //     case "ActiveStatus":
  //       updatePODData(
  //         selectedOption ? parseInt(selectedOption.value, 10) : STATUS_ACTIVE
  //       );
  //       break;
  //     case "FromDate":
  //     case "ToDate": {
  //       const formattedDate = selectedOption
  //         ? selectedOption.toLocaleDateString("en-US")
  //         : "";
  //       updatePODData(formattedDate);
  //       break;
  //     }
  //     case "KiosksCode":
  //       setinitiallogHistoryData((prev) => ({
  //         ...prev,
  //         KiosksCode: selectedOption?.label,
  //         KiosksID: selectedOption?.value,
  //       }));
  //       paramsCopy[name] = selectedOption?.label;
  //     default:
  //       updatePODData(selectedOption?.label || "");
  //       break;
  //   }

  //   // Add FacilityID and PodID to the params copy
  //   const updateFacilityID = {
  //     ...paramsCopy,
  //     FacilityID: facilityCode,
  //     PodID: podID,
  //   };

  //   // Dispatch the action for log history if not dealing with FromDate or ToDate
  //   if (!["FromDate", "ToDate"].includes(name)) {
  //     dispatch(PODAction.LoadInmateLoginLogHistory(updateFacilityID));
  //   }
  // };
  const handleLastName = (e) => {
    const searchData = { ...initiallogHistoryData };
    searchData.RowCountPerPage = 10;
    searchData.PageNo = 1;
    searchData.FacilityID = facilityCode;
    // searchData.LastName = e?.label ? e?.label : "";
    searchData.LastName = e?.value === 0 || e === null ? "" : e?.label;
    searchData.LastNameID = e?.value ? e?.value : 0;
    searchData.FirstName = "";
    searchData.FirstNameID = 0;
    searchData.PodID = podID;
    dispatch(PODAction?.updateInitiallogHistoryData(searchData));
    dispatch(
      masterActions.GetInmateFirstName({
        facilityID: facilityCode,
        LastName: e?.value === 0 || e === null ? "" : e?.label,
      })
    );
    dispatch(masterActions?.updateFirstName([]));
    dispatch(PODAction.LoadInmateLoginLogHistory(searchData));
  };

  const handleFirstName = (e) => {
    const searchData = { ...initiallogHistoryData };
    searchData.RowCountPerPage = 10;
    searchData.PageNo = 1;
    searchData.FacilityID = facilityCode;
    // searchData.FirstName = e?.label ? e?.label : "";
    searchData.FirstName = e?.value === 0 || e === null ? "" : e?.label;
    searchData.FirstNameID = e?.value ? e?.value : 0;
    searchData.PodID = podID;
    dispatch(PODAction?.updateInitiallogHistoryData(searchData));
    dispatch(PODAction.LoadInmateLoginLogHistory(searchData));
  };

  const updateSelectedOption = (e, select) => {
    const search = { ...initiallogHistoryData };
    search["RowCountPerPage"] = 10;
    search["PageNo"] = 1;
    search["PodID"] = podID;
    search["FacilityID"] = facilityCode;
    // if (select === "FromDate" || select === "ToDate") {
    //   const dateValue = fDate(e);
    //   search[select] = dateValue;
    // }
    if (select === "KiosksCode") {
      search[select] = e?.value == 0 ? "" : e?.label || "";
      search["KiosksID"] = e?.value || 0;
      dispatch(PODAction.LoadInmateLoginLogHistory(search));
    }
    else if (select === "ActiveStatus") {
      search[select] = e?.value == null ? 1 : e?.value;
      dispatch(PODAction.LoadInmateLoginLogHistory(search));
    }
    else {
      search[select] = e?.value || 0;
      dispatch(PODAction.LoadInmateLoginLogHistory(search));
    }
    dispatch(PODAction?.updateInitiallogHistoryData(search));
    // setinitiallogHistoryData(search);
  };

  const handleDate = (e, select) => {
    const search = { ...initiallogHistoryData };
    search["RowCountPerPage"] = 10;
    search["PageNo"] = 1;
    search["PodID"] = podID;
    search["FacilityID"] = facilityCode;
    if (select === "FromDate" || select === "ToDate") {
      const dateValue = fDate(e);
      search[select] = dateValue;
    }
    isPageChanged.current = true;
    dispatch(PODAction?.updateInitiallogHistoryData(search));
  };

  // Function to Exports POD data into an Excel file with specified columns and formatting.
  const generateExcelReport = () => {
    // Define the title of the Excel sheet
    const currentTime = exportDate(new Date());
    const title = `Log_${currentTime}`;
    // Define the column headers for Excel
    const generateExcelColumns = [
      "Date",
      "Inmate ID",
      "POD Name",
      "Kiosks Code",
      "Login Status",
    ];

    const updateTotalRows = {
      ...initiallogHistoryData,
      PageNo: 1,
      RowCountPerPage: logHistoryData?.TotalRecordCount,
      exportExcel: true,
      PodID: podID,
      FacilityID: facilityCode,
    };

    // Dispatch and process the response
    dispatch(PODAction?.LoadInmateLoginLogHistory(updateTotalRows))
      .then((response) => {
        // Ensure logHistoryFullData and DataList are valid
        const { DataList = [] } = response.payload || {}; // Assuming response contains DataList directly

        // Map the data for Excel
        const docList = DataList.map((obj) => ({
          Date: obj.LogInDateTime,
          InmateId: obj.InmateResidentId,
          PODName: obj.PODName,
          Kiosks: obj.KiosksCode,
          LoginStatus: obj.LoginStatus,
        }));

        // Check if there is data before generating the Excel
        if (docList.length === 0) return;
        generateXlsx(docList, generateExcelColumns, title);
      })
      .catch((error) => {
        // Handle errors gracefully
        console.error("Error loading Inmate Login Log History:", error);
      });
  };

  const handleRowPerPage = (page) => {
    // setIsRowPerPageChanged(true);
    if (isPageChanged?.current) return;
    const searchData = { ...initiallogHistoryData };
    searchData.RowCountPerPage = page;
    searchData.PageNo = 1;
    searchData.PodID = podID;
    searchData.FacilityID = facilityCode;
    dispatch(PODAction?.updateInitiallogHistoryData(searchData));
    // setinitiallogHistoryData(searchData);
    dispatch(PODAction.LoadInmateLoginLogHistory(searchData));
  };

  const handlePageChange = (page) => {
    if (isPageChanged?.current) {
      isPageChanged.current = false;
      return;
    }
    if (isSorting) {
      isSorting = false;
      return;
    }
    // setinitiallogHistoryData((prevState) => ({
    //   ...prevState,
    //   PageNo: page,
    // }));
    const searchData = { ...initiallogHistoryData };
    searchData.PageNo = page;
    searchData.PodID = podID;
    searchData.FacilityID = facilityCode;
    dispatch(PODAction?.updateInitiallogHistoryData(searchData));
    // setinitiallogHistoryData(searchData);
    dispatch(PODAction.LoadInmateLoginLogHistory(searchData));
    // setIsPageChanged(false);
  };

  //Sorting
  let isSorting = false; // to restrict the pagination issue
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;

    isSorting = true;
    const search = { ...initiallogHistoryData };
    const newSortOrder = search.SortBy.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortBy = `${column.key} ${newSortOrder}`;
    // setinitiallogHistoryData(search);
    dispatch(PODAction?.updateInitiallogHistoryData(search));
    dispatch(
      PODAction.LoadInmateLoginLogHistory({
        ...initiallogHistoryData,
        FacilityID: facilityCode,
        PodID: podID,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  if (loading || isLoading) return <CustomLoader />;

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handlePODSearchSubmit(e)}>
        {/* Inmate ID */}
        <div className="row">
          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateResidentId"
                id="InmateResidentId"
                label="Inmate ID"
                value={initiallogHistoryData.InmateResidentId}
                handleChange={handleInmateID}
                placeholder="Inmate ID"
                maxLength={18}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={logHistoryLastName}
                value={
                  initiallogHistoryData?.LastNameID !== "" ||
                    initiallogHistoryData?.LastNameID === 0
                    ? initiallogHistoryData?.LastNameID
                    : 0
                }
                handleChange={(e) => handleLastName(e, "LastName")}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={initiallogHistoryData?.LastName}
                //placeholder="--ALL--"
                label="Last Name"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              {/* First Name */}
              <SelectInput
                options={logHistorFirstName}
                value={
                  initiallogHistoryData?.FirstNameID !== "" ||
                    initiallogHistoryData?.FirstNameID === 0
                    ? initiallogHistoryData?.FirstNameID
                    : 0
                }
                handleChange={(e) => handleFirstName(e, "FirstName")}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={initiallogHistoryData?.FirstName}
                placeholder="-- Select --"
                label="First Name"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              {/* Gender */}
              <SelectInput
                options={genderDropdown}
                value={
                  initiallogHistoryData?.GenderID ||
                    initiallogHistoryData?.GenderID === 0
                    ? initiallogHistoryData?.GenderID
                    : 0
                }
                handleChange={(e) => updateSelectedOption(e, "GenderID")}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={initiallogHistoryData?.GenderID}
                label="Gender"
                defaultValue={0}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <DateInput
                label="From Date"
                value={
                  initiallogHistoryData?.FromDate
                    ? new Date(initiallogHistoryData?.FromDate)
                    : null
                } // Ensure proper date object
                handleChange={(e) => {
                  handleDate(e, "FromDate");

                  // Ensure ToDate is not before FromDate
                  // if (
                  //   initiallogHistoryData?.ToDate &&
                  //   new Date(selectedOption) >
                  //     new Date(initiallogHistoryData?.ToDate)
                  // ) {
                  //   updateSelectedOption(selectedOption, "ToDate");
                  // }
                }}
                name="FromDate"
                minDate={null}
                maxDate={
                  initiallogHistoryData?.ToDate
                    ? new Date(initiallogHistoryData?.ToDate)
                    : getCurrentDate()
                }
                yearDropDown={true}
                monthDropDown={true}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <DateInput
                label={"To Date"}
                value={
                  initiallogHistoryData?.ToDate
                    ? new Date(initiallogHistoryData?.ToDate)
                    : null
                } // Ensure proper date object
                handleChange={(e) => {
                  handleDate(e, "ToDate");

                  // Ensure FromDate is not after ToDate
                  // if (
                  //   initiallogHistoryData?.FromDate &&
                  //   new Date(selectedOption) <
                  //     new Date(initiallogHistoryData?.FromDate)
                  // ) {
                  //   updateSelectedOption(selectedOption, "FromDate");
                  // }
                }}
                name="ToDate"
                minDate={
                  initiallogHistoryData?.FromDate
                    ? new Date(initiallogHistoryData?.FromDate)
                    : null
                }
                maxDate={getCurrentDate()}
                yearDropDown={true}
                monthDropDown={true}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              {/* Status */}
              <SelectInput
                options={statusOptions}
                value={
                  initiallogHistoryData?.ActiveStatus ||
                    initiallogHistoryData?.ActiveStatus === 0
                    ? initiallogHistoryData?.ActiveStatus
                    : 1
                }
                handleChange={(e) => updateSelectedOption(e, "ActiveStatus")}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={initiallogHistoryData?.ActiveStatus !== 1}
                placeholder="--ALL--"
                label="Status"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={getSpecPodKiosk}
                value={
                  initiallogHistoryData?.KiosksID
                    ? // ||
                    // initiallogHistoryData?.KiosksCode === 0
                    initiallogHistoryData?.KiosksID
                    : 0
                }
                handleChange={(e) => updateSelectedOption(e, "KiosksCode")}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={initiallogHistoryData?.KiosksCode}
                // placeholder="--ALL--"
                label="Kiosk"
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="secondary"
            className="me-2"
            onClick={resetPODList}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            icon={"fa-solid fa-rotate-right"}
            disabled={false}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
          {/* Mobile only (Below md breakpoint) */}
          <div className="d-block d-md-none w-100 d-flex justify-content-end align-items-center mt-2">
            <Button
              label="Back"
              type="button"
              status="primary"
              icon={"fa-solid fa-angle-left"}
              onClick={() => {
                history.navigate("PODList");
              }}
            />
          </div>
          <div className="dd d-block d-md-none card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100">
            <div className="row justify-content-end mb-2 d-none d-md-block"></div>
            <div
              className=" d-flex align-items-center justify-content-between"
              style={{ background: "transparent", cursor: "pointer" }}
              onClick={toggleInformation}
            >
              {facilityCode !== 0 && (
                <h2 className=" form_title_uppercase text-color">
                  Login Log search
                </h2>
              )}
              <i
                id="itagInformation"
                className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                  }`}
                style={{ fontSize: "20px" }}
              ></i>
            </div>
            {showSearchFields && renderSearch()}
          </div>

          {/* Web only (Desktop and above) */}
          <div className="mb-3 d-none d-md-block">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
              {facilityCode !== 0 && (
                <h2 className=" form_title_uppercase text-color">
                  Login Log search
                </h2>
              )}
              <Button
                label="Back"
                type="button"
                status="primary"
                icon={"fa-solid fa-angle-left"}
                onClick={() => {
                  history.navigate("PODList");
                }}
              />
            </div>
          </div>
          {/* Web only (Desktop and above) */}
          <div className="d-none d-md-block">{renderSearch()}</div>
        </div>

        <>
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <h2 className="form_title_uppercase mb-4 text-color">
                Login Info
              </h2>
              <div className="d-flex flex-wrap gap-3 align-items-center">
                {shouldShowExcelExport && (
                  <ExcelExport
                    variant="soft-gray"
                    handleExcelExport={generateExcelReport}
                  />
                )}
              </div>
            </div>
            <Table
              //title={"POD List"}
              columns={columns}
              data={logHistoryData?.DataList}
              pagination
              // onChangeRowsPerPage={handleRowPerPage}
              // onChangePage={handlePageChange}
              onChangeRowsPerPage={(page) => handleRowPerPage(page)}
              onChangePage={(page) => handlePageChange(page)}
              totalRowCount={logHistoryData?.TotalRecordCount}
              currentPage={initiallogHistoryData?.PageNo}
              paginationPerPage={initiallogHistoryData?.RowCountPerPage}
              serverSideSort
              onSort={handleSort}
              sortColumn={initiallogHistoryData?.SortBy?.split(" ")[0]}
              sortDirection={initiallogHistoryData?.SortBy?.split(" ")[1]}
            />
          </div>
        </>
      </div>
    </div>
  );
};

export default React.memo(InmateLoginLog);
